import { FileWithPath } from "@mantine/dropzone"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"

type UploadCertificatePayload = {
  file: FileWithPath
  productionSiteId: string
  typeId: string
}

export const useUploadMutation = (
  options?: UseMutationOptions<string, AxiosError, UploadCertificatePayload>
) =>
  useMutation(
    async ({ file, productionSiteId, typeId }: UploadCertificatePayload) => {
      const formData = new FormData()
      formData.set("file", file)
      formData.set("productionSiteId", productionSiteId)
      formData.set("typeId", typeId)

      const response = await httpClient.post(
        "/v1/certificate/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      return response.data
    },
    {
      ...options,
    }
  )
